import React from 'react';
import './Brands.css';

// Import client logos
import PowerLogo from '../Assets/67d9309a2ed67eb64f70c4ad_Power.svg';
import LindeLogo from '../Assets/67d9309a2ed67eb64f70c4af_Linde client logo.svg';
import EurowagLogo from '../Assets/67d9309a2ed67eb64f70c4b0_Eurowag client logo.svg';
import GroupLogo from '../Assets/67d9309a2ed67eb64f70c4b1_Group 1000002724.svg';
import PGPGlassLogo from '../Assets/67d9309a2ed67eb64f70c4b2_PGP Glass client logo.svg';

const Brands = () => {
  const brands = [
    { name: 'Power', logo: PowerLogo },
    { name: 'Linde', logo: LindeLogo },
    { name: 'Eurowag', logo: EurowagLogo },
    { name: 'Group', logo: GroupLogo },
    { name: 'PGP Glass', logo: PGPGlassLogo }
  ];

  // Duplicate brands array for seamless scrolling
  const duplicatedBrands = [...brands, ...brands, ...brands];

  return (
    <section className="brands section">
      <div className="container">
        <div className="brands-header">
          <h2 className="section-title">Brands that trust Enculture</h2>
          <p className="section-description">
            Leading organizations rely on our culture assessment platform to transform their workplace environments
          </p>
        </div>
        
        <div className="brands-carousel">
          <div className="brands-track">
            {duplicatedBrands.map((brand, index) => (
              <div key={index} className="brand-item">
                <img 
                  src={brand.logo} 
                  alt={`${brand.name} logo`}
                  className="brand-logo"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;






